export const convertPOCategoryToLabel = (category: number) => {
  const categoryList = {
    1: "Sala Privativa",
    2: "BTS",
    3: "Posição Fixa",
    4: "Endereço Fiscal",
    5: "Projeto/Proposta",
  } as { [key: number]: string };

  return categoryList[category as keyof typeof categoryList] || "-";
};
